'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _Alert = require('./Alert');

var _Alert2 = _interopRequireDefault(_Alert);

var _util = require('./util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var wrapProps = function wrapProps(props) {
  var finalProps = props;

  if ((typeof props === 'undefined' ? 'undefined' : (0, _typeof3.default)(props)) !== 'object') {
    finalProps = {
      message: props
    };
  }

  return (0, _extends3.default)({}, finalProps);
};

_Alert2.default.success = function (props) {
  for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    rest[_key - 1] = arguments[_key];
  }

  return _util.alert.apply(undefined, [(0, _extends3.default)({
    type: 'success'
  }, wrapProps(props))].concat((0, _toConsumableArray3.default)(rest)));
};

_Alert2.default.warning = function (props) {
  for (var _len2 = arguments.length, rest = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    rest[_key2 - 1] = arguments[_key2];
  }

  return _util.alert.apply(undefined, [(0, _extends3.default)({
    type: 'warning'
  }, wrapProps(props))].concat((0, _toConsumableArray3.default)(rest)));
};

_Alert2.default.error = function (props) {
  for (var _len3 = arguments.length, rest = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    rest[_key3 - 1] = arguments[_key3];
  }

  return _util.alert.apply(undefined, [(0, _extends3.default)({
    type: 'danger'
  }, wrapProps(props))].concat((0, _toConsumableArray3.default)(rest)));
};

_Alert2.default.info = function (props) {
  for (var _len4 = arguments.length, rest = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    rest[_key4 - 1] = arguments[_key4];
  }

  return _util.alert.apply(undefined, [(0, _extends3.default)({
    type: 'info'
  }, wrapProps(props))].concat((0, _toConsumableArray3.default)(rest)));
};

_Alert2.default.clear = function () {
  return (0, _util.clear)();
};

exports.default = _Alert2.default;